import { ITemplateSheetTable } from "@/pages/template/component/TemplateSheet";

export const tempDocOptions = [
  {
    label: "White Card",
    value: "White Card",
  },
  {
    label: "Covid Vaccine Certificate",
    value: "Covid Vaccine Certificate",
  },
  {
    label: "Driver License",
    value: "Driver License",
  },
  {
    label: "Visa Copy",
    value: "Visa Copy",
  },
  {
    label: "Police Check",
    value: "Police Check",
  },
  {
    label: "Medical Check",
    value: "Medical Check",
  },
  {
    label: "Working with Children",
    value: "Working with Children",
  },
  {
    label: "11084NAT Asbestos Awareness",
    value: "11084NAT Asbestos Awareness",
  },
  {
    label: "10830NAT Crystalline Silica Exposure Prevention",
    value: "10830NAT Crystalline Silica Exposure Prevention",
  },
  {
    label: "Passport",
    value: "Passport",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const tempDesiredRolesOptions = [
  { label: "General Labour", value: "GENERAL_LABOUR" },
  { label: "Driver", value: "DRIVER" },
];

export const truthyOptions = [
  { label: "YES", value: "YES" },
  { label: "NO", value: "NO" },
];

export const itemDetail = {
  item: "",
  description: "",
  unit: "",
  quantity: 0,
  price: 0,
  margin: 0,
  total: 0,
};
export const itemDetail2 = {
  item: "",
  description: "",
  unit: "",
  quantity: 0,
  price: 0,
  margin: 0,
  total: 0,
  isCustom: true,
  customDetails: [],
};

export const customEstimationItem = {
  name: "",
  total: 0,
  note: "",
  details: [],
};

// export const status = [
//   {
//     value: "quote",
//     label: "Waiting to Quote",
//     color: "#9D50DD",
//   },
//   {
//     value: "awarded",
//     label: "Awarded",
//     color: "#9CD325",
//   },
//   {
//     value: "register",
//     label: "Waiting For Register",
//     color: "#FF5AC4",
//   },
//   {
//     value: "cmeci",
//     label: "CM/ECI",
//     color: "#FF6D3B",
//   },
//   {
//     value: "inprogress",
//     label: "In Progress < 50",
//     color: "#FDAB3D",
//   },
// ];

export const tempTemplateSheetTableData: ITemplateSheetTable[] = [
  {
    id: "1",
    label: "Client Name",
    type: "Dropdown",
    value: "Alphanumeric",
  },
  {
    id: "2",
    label: "Project Name",
    type: "Dropdown",
    value: "Alphanumeric",
  },
  {
    id: "3",
    label: "Report",
    type: "Dropdown",
    value: "Alphanumeric",
  },
  {
    id: "4",
    label: "Service",
    type: "Editable to Users",
    value: "Multiple options from items",
  },
  {
    id: "5",
    label: "Purchase Order",
    type: "Text Field",
    value: "Alphanumeric",
  },
  {
    id: "6",
    label: "Number of workers",
    type: "Text Field",
    value: "Numeric",
  },
  {
    id: "7",
    label: "Job Description",
    type: "Text Field",
    value: "Alphanumeric",
  },
  {
    id: "8",
    label: "Site Manager",
    type: "Text Field",
    value: "Alphanumeric",
  },
  {
    id: "9",
    label: "Disputes",
    type: "Toggle",
    value: "Yes/No",
  },
  {
    id: "10",
    label: "Signature",
    type: "Editor",
    value: "--",
  },
  {
    id: "11",
    label: "No project manager on site",
    type: "Toggle",
    value: "Yes/No",
  },
];
